import { createSlice } from "@reduxjs/toolkit"

const alertSlice = createSlice({
  name: "alert",
  initialState: {
    message: null,
    type: "success"
  },
  reducers: {

    showAlert: (state, action) => {
      state.message = action.payload.message
      state.type = action.payload.type || "success"
    },

    clearAlert: (state) => {
      state.message = null
    }

  }
})

export const { showAlert, clearAlert } = alertSlice.actions
export default alertSlice.reducer